import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';

import styles from './styles/TextField.module.scss';

function TextField(props: any) {
    const handleChange = (value: any) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    return(
        <InputGroup className={styles.textfield}>
            {props.title != undefined ? <Form.Label className={styles.label}>
                <InputGroup.Text>{props.title}</InputGroup.Text>
            </Form.Label> : null}
            <Form.Control
                className={styles.control}
                onKeyDown={ props.onKeyDown }
                type={ props.type }
                disabled={props.disabled}
                onChange={(evt) => handleChange(evt.target.value)}
                placeholder={props.placeholderValue}
                value={props.value !== undefined && props.value !== "" ? props.value : (props.defaultValue != undefined ? props.defaultValue : "")}
                data-lpignore={props.dataLpignore}
                autoComplete={props.autocomplete}
            />
        </InputGroup>
    );
}

export default TextField;